var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArchiveFile = function SvgArchiveFile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 66,
    viewBox: "0 0 65 66",
    width: 65,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m24.3765 18.3371-3.8296 3.8296 9.2462 9.2462 14.6629-14.6629-3.8295-3.8296-10.8334 10.8333z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.8756 16.75v24.375h-48.74995v-24.375h-5.41667v37.9167c0 2.1548.85603 4.2215 2.37976 5.7452s3.59036 2.3798 5.74526 2.3798h43.3333c2.1549 0 4.2215-.8561 5.7453-2.3798 1.5237-1.5237 2.3797-3.5904 2.3797-5.7452v-37.9167z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.2507 8.62498h32.4999v29.79162h5.4167v-32.49995c0-.7183-.2853-1.40717-.7932-1.91508-.508-.50792-1.1968-.79326-1.9151-.79326h-37.9167c-.7183 0-1.4072.28534-1.9151.79326-.5079.50791-.7932 1.19678-.7932 1.91508v32.49995h5.4167z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArchiveFile, _extends({
    svgRef: ref
  }, props));
});
export default "https://static.im-cdn.com/mjc/storefront/Cipher/static/media/ArchiveFile.c59fbd37.svg";
export { ForwardRef as ReactComponent };